
import { Injectable, DOCUMENT, inject } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private document = inject<Document>(DOCUMENT);
  private logger = inject(NGXLogger);


  private canonicalLink;

  constructor() { 
    let link = this.document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    this.canonicalLink = link;
  }

  public updateMetadata(metadata: {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
  }) {
    if (metadata.title) {
      this.setTitle(metadata.title);
      this.metaService.updateTag({property: 'og:title', content: metadata.title});
    }
    if (metadata.description) {
      this.metaService.updateTag({name: 'description', content: metadata.description});
      this.metaService.updateTag({property: 'og:description', content: metadata.description});
    }
    if (metadata.image) {
      metadata.image = this.translateImage(metadata.image);
      this.logger.debug('Setting og:image to:', metadata.image);
      this.metaService.updateTag({property: 'og:image', content: metadata.image});
    }
    if (metadata.url) {
      metadata.url = +metadata.url.startsWith('/') ? `https://sencha-tea.com/fe${metadata.url}` : metadata.url;
      this.logger.debug('Setting og:url to:', metadata.url);
      this.metaService.updateTag({property: 'og:url', content: metadata.url});
    }
  }

  public setTitle(title: string) {
    this.titleService.setTitle(title);
  }

  public setMetaTags(metaTags: any) {
    if (metaTags['og:image']) {
      metaTags['og:image'] = this.translateImage(metaTags['og:image']);
      this.logger.debug('Setting og:image to:', metaTags['og:image']);
    }
    this.logger.debug('Setting meta tags:', metaTags);
    this.metaService.addTags(metaTags);
  }

  public setCanonicalLink(url: string) {
    this.canonicalLink.setAttribute('href', url);
  }

  translateImage(image: string) {
    let translation = image;
    if (image.startsWith('/')) {
      translation = `https://static.sencha-tea.com/fe${image}`;
    } else if (image.startsWith('https://senchatea.retool.com/')) {
      translation = `https://static.sencha-tea.com/rt/${image.split('/').pop()}`;
    }
    const optimised = `https://sencha-tea.com/cdn-cgi/image/width=1200,height=630,fit=pad/${translation}`;
    return optimised;
  }
}